import fetch from "@/utils/request";

export default {
  getFundProductList(data?: {
    page?: number;
    page_size?: number;
    fund_type?: number;
  }): any {
    return fetch({
      url: "/php/api/fund_product/list",
      method: "get",
      data: {
        fund_type: 1,
        ...data
      },
      customLoading: true
    });
  },
  getFundProductDetail(data: { id: number | string }): any {
    return fetch({
      url: "/php/api/fund_product/detail",
      method: "get",
      data,
      customLoading: true
    });
  },
  getFundProductNavHistory(data: { product_id: number | string }): any {
    return fetch({
      url: "/php/api/fund_product/nav_history",
      method: "get",
      data,
      customLoading: false
    });
  },
  subscribeFundProduct(data: {
    fund_product_id: number | string;
    futures_login_id: string;
    subscription_amount: string;
    agree_terms: 1;
  }): any {
    return fetch({
      url: "/php/api/fund_product/subscribe",
      method: "post",
      data,
      customLoading: true
    });
  },
  getFundProductOrderList(data?: {
    page?: number;
    page_size?: number;
    fund_type?: number;
  }): any {
    return fetch({
      url: "/php/api/fund_product/order/list",
      method: "get",
      data: {
        ...data
      },
      customLoading: true
    });
  }
};
